/* The thread's messages: board M's sizes (the screen), board O's details (the answers bundle, the
 * disclosure line). */

.bubble {
  align-self: flex-end;
  max-width: 78%;
  margin: var(--space-0);
  padding: var(--space-10px) var(--space-4);
  font-size: var(--fs-body);
  line-height: var(--lh-buddy-message);
  overflow-wrap: anywhere;
  white-space: pre-wrap;
  background: var(--bg-chip);
  border-radius: var(--radius-20px) var(--radius-20px) var(--radius-xs) var(--radius-20px);
}

.answers {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  white-space: normal;
}

.answerList {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  margin: var(--space-0);
}

.question {
  font-size: var(--fs-note);
  color: var(--text-2);
}

.answer {
  margin: var(--space-minus-5px) var(--space-0) var(--space-0);
  font-weight: var(--fw-medium);
}

.buddy {
  display: flex;
  gap: var(--space-3);
  align-items: flex-start;
}

.mark {
  width: 20px;
  height: 20px;
  margin-top: var(--space-1px);
}

.body {
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: var(--space-3);
  min-width: 0;
}

/* „Pokaż kroki": the turn's steps, folded by default, a quiet line rather than a card. */
.steps {
  display: flex;
  flex-direction: column;
  gap: var(--space-7px);
}

.stepsTrigger {
  display: inline-flex;
  gap: var(--space-5px);
  align-items: center;
  align-self: flex-start;
  font-family: var(--font-body);
  height: 28px;
  margin-left: var(--space-minus-6px);
  padding: var(--space-0) var(--space-2) var(--space-0) var(--space-6px);
  font-size: var(--fs-foot);
  font-weight: var(--fw-regular);
  color: var(--text-2);
  cursor: pointer;
  background: transparent;
  border: none;
  border-radius: var(--radius-xs);
}

.stepsTrigger:hover {
  color: var(--text);
  background: var(--hover-tint);
}

.stepsTrigger:active {
  background: var(--bg-chip);
}

.stepsTrigger:focus-visible {
  outline: var(--border-focus) solid var(--focus);
  outline-offset: var(--space-2px);
}

.stepsChevron {
  flex: none;
  width: 14px;
  height: 14px;
  color: var(--text-2);
  transition-duration: var(--dur-buddy-chevron);
  transition-property: transform;
  transition-timing-function: var(--ease-buddy-spring);
}

.stepsTrigger[data-panel-open] .stepsChevron {
  transform: rotate(90deg);
}

/* Indented by the chevron and its gap, so each step stands under the label's words. */
.stepList {
  display: flex;
  flex-direction: column;
  gap: var(--space-5px);
  margin: var(--space-0);
  padding: var(--space-0) var(--space-0) var(--space-0) var(--space-19px);
  font-size: var(--fs-foot);
  color: var(--text-2);
  overflow-wrap: anywhere;
  list-style: none;
}

.text {
  margin: var(--space-0);
  font-size: var(--fs-body);
  line-height: var(--lh-buddy-message);
  overflow-wrap: anywhere;
}

.text b {
  font-weight: var(--fw-semibold);
}

/* One streamed word, clearing from its blur; its place in the stream is `--word-index`. */
.word {
  animation-name: word-in;
  animation-duration: var(--dur-buddy-word);
  animation-timing-function: var(--ease);
  animation-fill-mode: both;
  animation-delay: calc(var(--word-index, 0) * var(--dur-buddy-word-step));
}

[data-still] .word {
  animation-name: none;
}

.disclosure {
  display: flex;
  gap: var(--space-10px);
  align-items: center;
  margin: var(--space-0);
  padding: var(--space-10px) var(--space-14px);
  font-size: var(--fs-note);
  font-weight: var(--fw-regular);
  color: var(--text-2);
  border: var(--border-hairline) solid var(--border);
  border-radius: var(--radius-12px);
}

.disclosure b {
  font-weight: var(--fw-medium);
  color: var(--text);
}

.disclosureMark {
  width: 18px;
  height: 18px;
}

@keyframes word-in {
  from {
    opacity: 0;
    filter: var(--filter-buddy-word-in);
  }

  to {
    opacity: 1;
    filter: none;
  }
}
